import React, { Suspense, useEffect, useRef, useState } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import { AuthProvider } from './auth'
import AuthConsumer from './auth/auth-consumer'
import SplashScreen from './components/splash-screen/splash-screen'
import { CToaster } from '@coreui/react-pro'
import { useDispatch, useSelector } from 'react-redux'
import Toast from './components/Toast/Toast'
import { setDisplayMessage, setRouteToNavigate } from './redux/slices/login.slice'

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
// Pages
const Login = React.lazy(() => import('./views/pages/login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

const App = () => {
  const dispatch = useDispatch()
  const { displayMessage } = useSelector((state) => state.login)
  const [toast, setToast] = useState(0)
  const toaster = useRef(null)

  useEffect(() => {
    const href = window.location.href
    if (href.endsWith('?route=rfx')) {
      const h = href.toString().split('/#')
      const url = href.toString().split('/#').pop().slice(0, -10)
      dispatch(setRouteToNavigate(url))
      const navURL = h[0] + '/#' + url
      window.location.href = navURL
    }
  }, [])

  useEffect(() => {
    if (displayMessage) {
      setToast(Toast(displayMessage.message, displayMessage?.type))
      dispatch(setDisplayMessage(null))
    }
  }, [displayMessage])

  return (
    <HashRouter>
      <>
        <CToaster ref={toaster} push={toast} placement="top-end" />
        <AuthProvider>
          <AuthConsumer>
            <Suspense fallback={<SplashScreen />}>
              <Routes>
                <Route exact path="/" name="Login Page" element={<Login />} />
                <Route exact path="/register" name="Register Page" element={<Register />} />
                <Route exact path="/404" name="Page 404" element={<Page404 />} />
                <Route exact path="/500" name="Page 500" element={<Page500 />} />
                <Route path="*" name="Home" element={<DefaultLayout />} />
              </Routes>
            </Suspense>
          </AuthConsumer>
        </AuthProvider>
      </>
    </HashRouter>
  )
}

export default App
